import React, {Component, useState} from 'react';
import {useSelector, useDispatch, connect} from 'react-redux';
import {Link} from "react-router-dom";
import {GET_DEPARTEMENTS_FAIL, SET_MENUHEADER} from "../../actions/types";
import i18n from "../../i18n";
import {Trans} from "react-i18next";


const MainHeader = () => {
  const dispatch = useDispatch();
  const menuheader = useSelector(state => state.menuheader);
  // const { i18n } = useTranslation();
  // onClick={(e) => i18n.changeLanguage('fr')}
  // const [activeRoute, setActiveRoute] = useState('');

  if (menuheader.menulocation !== window.location.pathname){
    dispatch({type: SET_MENUHEADER, payload: {menuactive: window.location.pathname, menulocation: window.location.pathname},});
  }
  const handleOnclick=(e)=>{
    e.preventDefault();
    // console.log("MainHeader:handleOnClickLang", i18n.t('goback_home'));
    // setLanguage(e.target.value);
    i18n.changeLanguage(e.target.lang);

    window.location.reload();
  }

  return (
      <header className="fixed-top" role="banner" id="omp-portal-header">
        {/* <!-- Primary navigation bar --> */}
        <nav role="navigation" className="navbar navbar-dark navbar-expand-md supra"
             aria-label="Complementary navigation">
          <div className="container-fluid">
            <ul className="navbar-nav">
              <li className="nav-item">
                <a className="nav-link" rel={"noreferrer"} href={"http://www.orange.cm/"} target={"_blank"}>
                  <Trans>header_menutop_particular</Trans>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" rel={"noreferrer"} href={"http://business.orange.cm/"} target={"_blank"}>
                  <Trans>header_menutop_business</Trans>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" rel={"noreferrer"}
                   href={"http://www.orange.cm/particuliers/1/4/agences-et-points-de-vente-38280.html"}
                   target={"_blank"}>
                  <Trans>header_menutop_pointvente</Trans>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" rel={"noreferrer"} href={"http://www.orange.cm/particuliers/1/4/assistance-en-ligne-111811.html"}
                   target={"_blank"}>
                  <Trans>header_menutop_assistance</Trans>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" rel={"noreferrer"} href={"https://client.orange.cm/"} target={"_blank"}>
                  <Trans>header_menutop_espaceclient</Trans>
                </a>
              </li>
            </ul>
            <ul className="navbar-nav ml-auto">
              <li className="nav-item px-1">
                <a className={"text-decoration-none "+(i18n.language === "fr" ? "text-uppercase text-primary" : "text-white text-lowercase")} href="#" onClick={handleOnclick} lang="fr" >FR</a>
              </li>
              <li className="nav-item px-1">
                <a className={"text-decoration-none "+(i18n.language === "en" ? "text-uppercase text-primary" : "text-white text-lowercase")} href="#" onClick={handleOnclick} lang="en" >EN</a>
              </li>
            </ul>
          </div>
        </nav>
        <nav className="navbar navbar-dark navbar-expand-md" role="navigation" aria-label="Main navigation">
          <div className="container-fluid pt-2 pb-2">
            <Link className="navbar-brand omp-no-padding omp-no-marging" onClick={(e) => {dispatch({type: SET_MENUHEADER, payload: {menuactive: '', menulocation: '/'},})}} to="/">
              <img src="assets/dist/img/orange_logo.svg" alt="Back to homepage" title="Back to homepage"
                   width="40" height="40" loading="lazy"/>
              <span className="ml-2 align-self-end">
                <span className="sr-only">Orange</span>&nbsp;&nbsp;
              </span>
            </Link>
            <div className="d-lg-none d-md-none d-sm-inline">
              <div className="d-inline px-1">
                <a className={"h4 text-decoration-none "+(i18n.language === "fr" ? "text-uppercase text-primary" : "text-white text-lowercase")} href="#" onClick={handleOnclick} lang="fr" >FR</a>
              </div>
              <div className="d-inline px-1">
                <a className={"h4 text-decoration-none "+(i18n.language === "en" ? "text-uppercase text-primary" : "text-white text-lowercase")} href="#" onClick={handleOnclick} lang="en" >EN</a>
              </div>
            </div>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsing-navbar"
                    aria-controls="collapsing-navbar" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="navbar-collapse justify-content-between collapse" id="collapsing-navbar">
              <ul className="navbar-nav mr-auto">
                <li className="nav-item">
                  <Link className={menuheader.menulocation === "/" ? "nav-link active" : "nav-link"} onClick={(e) => {dispatch({type: SET_MENUHEADER, payload: {menuactive: '', menulocation: '/'},})}} to="/"> <Trans>header_menu_home</Trans></Link>
                </li>
                <li className="nav-item">
                  <Link className={menuheader.menulocation.includes("/productpay") ? "nav-link active" : "nav-link"} onClick={(e) => {dispatch({type: SET_MENUHEADER, payload: {menuactive: 'productpay', menulocation: '/productpay/none'},})}} to="/productpay/none"><Trans>header_menu_schoolexamfees</Trans></Link>
                </li>
                <li className="nav-item">
                  <Link className={menuheader.menulocation.includes("/payment") ? "nav-link active" : "nav-link"} onClick={(e) => {dispatch({type: SET_MENUHEADER, payload: {menuactive: 'payment', menulocation: '/payment'},})}} to="/payment"><Trans>header_menu_findpayment</Trans></Link>
                </li>
                <li className="nav-item">
                  <Link className={menuheader.menulocation.includes("/school") ? "nav-link active" : "nav-link"} onClick={(e) => {dispatch({type: SET_MENUHEADER, payload: {menuactive: 'school', menulocation: '/school'},})}} to="/school"><Trans>header_menu_searchcode</Trans></Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
  )
}

export default MainHeader
// export default () => {
//   const { t, i18n } = useTranslation();
//
//   return (
//       <MainHeader />
//   )
// }
